import { createCirclePolygon } from './shapes.js';
export const createCircularHolePolygon = (hole)=>{
    const { $absCoords: center, radius } = hole;
    return createCirclePolygon({
        center,
        radius
    });
};

//# sourceMappingURL=circular-hole.js.map